<template>
    <div>
        <or-page-title>Новости</or-page-title>
        <div class="layout-1200 padding-bottom-50">
            <div v-if="!selected_news" class="container padding-top-50">
                <or-news-card 
                    class="card"
                    v-for="(item, i) in news" 
                    :key="i" 
                    :options="item"
                    @click="select(item)"
                />
                <or-button v-show="additional_part_of_news < all_news.length" class="button" @click="more_news" :options="{
                                        text: 'Больше новостей',
                                        class: 'stroke-button',
                                        style: {
                                            width: '210px',
                                            height: '40px',
                                            borderRadius: '8px',
                                        },
                                        animation: 'anim-sub-button'
                                        }"/>
            </div>
            <or-news-content class="news" :news="selected_news" :scroll_top="scroll_top" @close="selected_news = null" v-else/>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Axios from 'axios'
import orPageTitle from '../global/or-page-title.vue'
import orButton from '../global/or-button.vue'
import orNewsCard from './parts/news-page/or-news-card.vue'
import orNewsContent from './parts/news-page/or-news-content.vue'
export default {
    components: {orPageTitle, orButton, orNewsCard, orNewsContent},
    data() {
        return {
            selected_news: null,
            all_news: [

            ],
            news: [
            ],
            scroll_top: 0,
            additional_part_of_news: 0,
        }
    },
    computed: {
        ...mapGetters({getNews: 'getNews'}),
    },
    mounted() {
        if (this.getNews === null) {
            this.changeIsPageReady({is: false});
        }
        const i = setInterval(()=>{
            if (this.getNews !== null) {
                clearInterval(i);
                this.getFromState()
            }
        }, 10);
    },
    methods: {
        ...mapActions({changeIsPageReady: 'changeIsPageReady', changeNews: 'changeNews'}),
        getFromState() {
            this.all_news = this.getNews;
            this.more_news();
            this.changeIsPageReady({is: true});
        },
        select(news) {
            this.selected_news = news;
            this.scroll_top = window.scrollY;
        },
        more_news() {
            const counter = this.additional_part_of_news;
            for (let i = counter; i < counter + 5; i++) {
                if (i >= this.all_news.length) break;
                const el = this.all_news[i];
                this.news.push({
                    title: el.title,
                    text: el.text,
                    date: el.date,
                })
                this.additional_part_of_news++;
            }
        }
    },

}
</script>

<style scoped>
    .card {
        margin-bottom: 50px;
    }
    .card:last-of-type {
        margin-bottom: 0px;
    }
    .button {
        margin: 0 auto;
    }
</style>